// extracted by mini-css-extract-plugin
module.exports = {"borderWrapper":"MonitoringStatusCell_borderWrapper__3pw7o","borderMargin":"MonitoringStatusCell_borderMargin__2eKwk"};